import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '../../../grid';
import { colors, globalStyles } from '../../../../constants';

const ButtonHelper = ({ arrowColour, text }) => (
  <Box position="relative" width="max-content">
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.632301 0.471769L13.2729 6.41758L1.78547 14.166L0.632301 0.471769Z" fill={arrowColour} />
    </svg>
    <StyledBox
      position="absolute"
      top="14px"
      left="14px"
      backgroundColor="orange400"
      borderRadius="2px"
      p="0.5rem"
      fontFamily={globalStyles.brandFontFamily}
    >
      {text}
    </StyledBox>
  </Box>
);

const StyledBox = styled(Box)`
  white-space: nowrap;
`;

ButtonHelper.propTypes = {
  text: PropTypes.string,
  arrowColour: PropTypes.string,
};

ButtonHelper.defaultProps = {
  text: '1 in 4 chance to win',
  arrowColour: colors.neonTeal400,
};

export { ButtonHelper };
